const MOBILE_DEVICE_TYPES = {
  IOS: 'iOS',
  ANDROID: 'Android',
};
export default MOBILE_DEVICE_TYPES;
